import type { MemberPaymentOptions } from '@/api/member';

export type RechargeTab = 'cny' | 'usdt';

export function availableRechargeMethods(options: MemberPaymentOptions | null, tab: RechargeTab) {
  if (!options?.enabled) return [];
  const packages = tab === 'usdt' ? options.usdtPackages ?? [] : options.packages ?? [];
  return (options.methods ?? []).filter((method) =>
    (tab === 'usdt' ? method.id === 'usdt' : method.id === 'alipay' || method.id === 'wechat') &&
    packages.some((pkg) => (method.availablePackageIds ?? []).includes(pkg.id)),
  );
}

export function initialRechargeTab(options: MemberPaymentOptions): RechargeTab {
  return availableRechargeMethods(options, 'cny').length ? 'cny' : 'usdt';
}
